export const PAGE_LIMIT = 100
export const DROP_DOWN_LIST_LIMIT = 7
